module.exports = __webpack_public_path__ + "img/polygon-op.1b64764e.svg";